<template>
    <div class="big-iframe clearfix">
        <iframe class="big-iframe" :src="url[0].url" frameborder="0" v-if="url != '' && url[0].url != 'error'"></iframe>
        <div class="error-warp ac" v-if="error">
            <img src="/static/images/404.png">
            <h2 class="mt10 color-8a8a99">页面路径错误</h2>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            key:this.$route.query.url,
            url:'',
            error:false
        }
    },
    watch: {
        $route(){
            this.key = this.$route.query.url;//获取当前页面url的key
            this.routeJudge();
        }
    },
    mounted() {
		let that = this;
        that.routeJudge();
    },
    created() {
		
    },
    methods: {
       //路径判断
		routeJudge () {
            let that = this;
			if(that.$parent.iframeMenus != ''){
				let menu = that.$parent.iframeMenus.menuMap;
				let url = '';
				url = menu.filter((item, index, arr) => item.key === that.key);
				if(url == '' || url[0].url === 'error'){
				    that.error = true;
				}
				that.url = url;
				let menuName = url[0].menuName;//获取当前路由的title
				document.title = menuName+'_'+that.$parent.company.config.systemTitle;
				return;
			}
			setTimeout(() =>{
				this.routeJudge();
			},1000)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/page/iframe.vue